export const textSizeClasses = {
  xxs: "text-[10px]",
  xs: "text-xs",
  sm: "text-sm",
  base: "text-base",
  lg: "text-3xl",
  xl: "text-4xl",
  xxl: "text-8xl",
} as const;

export type TextSize = keyof typeof textSizeClasses;

export type ResponsiveTextSize = {
  mobile: TextSize;
  desktop: TextSize;
};

export const responsiveTextSizeDefaults: Record<TextSize, ResponsiveTextSize> =
  {
    xxs: { mobile: "xxs", desktop: "xxs" },
    xs: { mobile: "xs", desktop: "xs" },
    sm: { mobile: "sm", desktop: "sm" },
    base: { mobile: "base", desktop: "base" },
    lg: { mobile: "lg", desktop: "lg" },
    xl: { mobile: "xl", desktop: "xl" },
    xxl: { mobile: "xxl", desktop: "xxl" },
  } as const;

export const DEFAULT_TEXT_SIZE: TextSize = "base";
export const DEFAULT_RESPONSIVE_TEXT_SIZE =
  responsiveTextSizeDefaults[DEFAULT_TEXT_SIZE];
